<template>
  <div class="container employees_review_block">
    <swiper
      class="position-relative employees_review_block__carousel"
      next_btn_class="image_next_btn"
      prev_btn_class="image_prev_btn"
      :slides_per_view="1.2"
      :breakpoints="swiper_breakpoints">
      <swiper-slide
        v-for="(review, index) in reviews"
        class="employees_review_block__slide"
        :key="`swiper-slide_${index}_${uid}`">
        <div class="employees_review_block__slide-content">
          <blockquote-icon/>
          <html-block
            :content="review.content"
            class="employees_review_block__slide-content-text"/>
        </div>
        <div class="employees_review_block__slide-info">
          <div class="employees_review_block__slide-info_desc">
            <div class="employees_review_block__slide-info_name"><b>{{review.employee_name}}</b></div>
            <div class="employees_review_block__slide-info_position">{{review.employee_position}}</div>
          </div>
          <lazy-image
            class="employees_review_block__slide-info_img"
            cover_img
            :src="review.image_src"
            :lazy_src="review.image_lazy_src"
            :alt="`main-slide_${index}`"/>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>

import LazyImage from "../small_parts/LazyImage.vue";
import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import uid_mixin from "../../mixins/uid_mixin";
import BlockquoteIcon from "../icons/BlockquoteIcon.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";

export default {
  name: "EmployeesReviewBlock",
  mixins: [uid_mixin],
  components: {
    HtmlBlock,
    BlockquoteIcon,
    SwiperSlide,
    Swiper,
    LazyImage
  },
  props: {
    /**props**/
    reviews: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        image_src: {
          type: String,
          required: true,
          admin_type: 'image',
        },
        image_lazy_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        employee_name: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        employee_position: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        content: {
          type: String,
          default: '',
          admin_type: 'editor',
        },
      }
    },
    /**props**/
  },
  computed: {
    swiper_breakpoints() {
      return {
        576: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20
        },
      }
    },
  }
}
</script>
